"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _mappingToColumnsType = _interopRequireDefault(require("./mappingToColumnsType"));

var _columnsToGraphql = require("./utils/columnsToGraphql");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(mapping) {
  return (0, _mappingToColumnsType["default"])(mapping).map(function (_ref) {
    var field = _ref.field,
        type = _ref.type;
    var id = field.replace(/hits\.edges\[\d*\].node\./g, '');
    return _objectSpread({
      show: false,
      type: type,
      sortable: type !== 'list',
      canChangeShow: type !== 'list',
      field: id
    }, type === 'list' ? {
      query: (0, _columnsToGraphql.toQuery)({
        accessor: field
      }),
      jsonPath: "$.".concat(field.replace(/\[\d*\]/g, '[*]'))
    } : {
      accessor: field
    });
  });
};

exports["default"] = _default;